import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'

// Transfer rental between accounts (reservation only)
export function useTransferRental() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      fromAccount,
      toAccount,
    }: {
      fromAccount: string
      toAccount: string
    }) => {
      const { data, error } = await client.POST('/api/v1/transfer', {
        body: { from_account: fromAccount, to_account: toAccount },
      })
      if (error) throw error
      return data
    },
    onSuccess: (_data, { fromAccount, toAccount }) => {
      // Invalidate both accounts
      queryClient.invalidateQueries({
        queryKey: queryKeys.accounts.status(fromAccount),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.accounts.status(toAccount),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.rentals.current(fromAccount),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.rentals.current(toAccount),
      })
    },
  })
}

// Continue rental on another account (end trip + book on new account)
export function useContinueRental() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      endOnAccount,
      continueOnAccount,
    }: {
      endOnAccount: string
      continueOnAccount: string
    }) => {
      const { data, error } = await client.POST('/api/v1/continue', {
        body: {
          end_on_account: endOnAccount,
          continue_on_account: continueOnAccount,
        },
      })
      if (error) throw error
      return data
    },
    onSuccess: (_data, { endOnAccount, continueOnAccount }) => {
      // Invalidate both accounts
      queryClient.invalidateQueries({
        queryKey: queryKeys.accounts.status(endOnAccount),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.accounts.status(continueOnAccount),
      })
      queryClient.removeQueries({
        queryKey: queryKeys.rentals.current(endOnAccount),
      })
      queryClient.removeQueries({
        queryKey: queryKeys.rentals.fuelCard(endOnAccount),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.rentals.current(continueOnAccount),
      })
      queryClient.invalidateQueries({ queryKey: queryKeys.vehicles.all })
    },
  })
}
